<div>
  <div *ngIf="isPriceImpactExceeded" class="alert-warning">
    <div class="w-full flex flex-row">
      <ng-icon
        name="hero-exclamation-triangle-mini"
        size="20"
        class="mt-0.5 text-gray-light"
      ></ng-icon>
      <div class="flex-1 flex flex-col">
        <div class="flex flex-row">
          <span
            class="mr-5 text-xs"
            [innerHtml]="'rebalancing.issue.maxPriceImpact.info' | translate"
          ></span>
          <div class="flex-1 flex flex-row justify-end">
            <span class="text-xs"
              >{{ 'rebalancing.issue.maxPriceImpact.max' | translate }}:
              {{ maxPriceImpact | percent: '0.2-2' }}</span
            >
            <span class="ml-2 md:ml-4 text-xs"
              >{{ 'rebalancing.issue.maxPriceImpact.actual' | translate }}:
              {{ actualPriceImpact | percent: '0.2-2' }}</span
            >
          </div>
        </div>
        <div
          *ngIf="relevantAssets?.length"
          class="mt-2 border-t border-t-orange-100 pt-2 flex flex-row items-center"
        >
          <span>{{
            'rebalancing.issue.maxPriceImpact.refPrices' | translate
          }}</span>
          <div class="ml-2 flex flex-row">
            <a
              *ngFor="let asset of relevantAssets"
              [href]="BLOCK_EXPLORER_TOKEN_LINK(asset.token.address, chain)"
              target="_blank"
              class="ml-2 flex flex-row h-fit px-2 py-1.5 rounded-lg bg-orange-100 hover:bg-orange-50 cursor-pointer"
            >
              <common-token-logo
                [token]="asset.token"
                [size]="3"
                [mdSize]="4"
                class="self-center min-w-[12px] md:min-w-[16px]"
              ></common-token-logo>
              <span class="ml-1 text-xs">{{ asset.token.symbol }}</span>
              <span class="ml-2 text-xs">{{ asset.price.usd | currency }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
